// const appUrl = "http://3.13.64.97:4001";
const appUrl = "https://backend.vorienx.com";

// const appUrl = "http://localhost:4001";
const appUrl2 = appUrl

export const deployedUrl = `${window.origin}/`

export const ApiConfig = {
  // =========EndPoints==========
  loginwithGoogle: 'user/third-party-login',
  signupwithGoogle: 'user/third-party-signup',
  login: "login",
  registerEmail: "register-email",
  registerPhone: "register-phone",
  registrationOtp: "registration-otp",
  verifyRegistrationToken: "verify-registration-token",
  verifyRegistrationOtp: "verify-registration-otp",
  getOtp: "send-otp",
  getcode: "verify-otp",
  forgotpassword: "forgot_password",
  activityLogs: "get_logs",
  setCurrency: "currency-preference",
  userfunds: "user-wallet",
  userP2pWallet: "p2p-wallet",
  walletHistory: 'wallet-history',
  depositHistory: 'wallet-deposit-history',
  withdrawalHistory: 'wallet-withdrawal-history',
  generateAddress: "generate-address",
  estimatedPortfolio: "estimated-portfolio",
  withdrawalcurrencypath: 'withdrawal',
  identity: "submit-kyc",
  categoryList: 'coin-category-list',
  favoriteCoin: 'favorite-coin',
  favoriteList: 'favorite-list',
  setSecurity: "change_password",
  updateSettings: "edit-profile",
  placeOrder: 'place-order',
  pastOrder: 'past-order',
  cancelOrder: 'cancel-order',
  coinDetails: 'coin-details',
  update2fa: "enable-2fa",
  googleAuth: "generate-google-qr",
  getHistoricalData: 'historical-data',
  getDetails: "profile",
  depositInr: 'deposit_inr',
  withdrawalInr: 'withdraw_inr',
  adminBankDetails: 'get_user_bank_details',
  userBankDetails: 'get_user_bank_details',
  editBank: 'user_bank_details',
  sendkginotp: 'send-kgin-otp',
  verifykginotp: 'verify-kgin-otp',
  notifiactionlist: 'user-notifications',
  reffercode: 'user_refer_code',
  getPairs: 'get-pairs',
  getMemePairs: 'get-meme-pairs',
  convertToken: "v1/swapping/convertToken",
  swapToken: "v1/swapping/swapToken",
  coinListedDetails: "send-coin-listing-request",
  partnerships: "signUp",
  total_refer_count: "total_refer_count",
  refer_list: "referral_user_list",
  referral_balance: "referral_balance",
  joining_balance: "joining_balance",
  coin_details: "coin-details",
  get_top_GL: "get_top_GL",
  get_trending: "get_trending",
  user_cancel_withdrawal: "user_cancel_withdrawal",
  cancel_all_order: "cancel_all_order",
  verify_deposit: "verify-deposit",
  bannerList: "banner_list",
  p2pCoinList: "p2p_coin_list",
  addBankDetails: "add-bank-details",
  addUpiDetails: "add_user_upi",
  getCoinList: "get-coin",
  editUpiDetails: 'edit_user_upi',
  editBankDetails: 'edit-bank-details',
  submitTicket: "submit-ticket",
  getUserTickets: "get-user-tickets",
  replyTicket: "user-reply-ticket",
  getLatestNews: "get_latest_news",
  quick_buy_sell: "quick_buy_sell",
  quickBuySellHistory: "history",
  getPartnerName: "getPartnerName",
  getCvbotUserWallet: "get-user-wallet",
  markasAllRead: "mark-all-as-read",
  markasRead: "mark-as-read",
  depositCvbotFunds: "deposit-balance",
  accessTokenSumsub: "access-token-sumsub",
  editavatar: "edit-avatar",
  editusername: "edit-name",
  editemail: "edit-email",
  editPhone: "edit-phone",
  depositActiveCoins: "deposit-active-coins",
  depositAddressList: "deposit-address/list",
  depositRequestSubmit: "deposit-request/submit",
  depositRequestList: "deposit-request/list",
  availableWalletTypes: "available-wallet-types",
  walletTransfer: "wallet-transfer",
  getPerticularWalletBalance: "get-perticular-wallet-balance",
  getWalletBalance: "get-wallet-balance",
  walletTransferHistory: "wallet-transfer-history",
  bonusHistory: "bonus-history",
  withdrawActiveCoins: "withdraw-active-coins",
  allCoins: "all-coins",
  blogList: "blog-list",
  viewBlog: "view-blog",
  baseCurrencyList: "base_currency_list",
  getConversionRate: "get_conversion_rate",
  getApk: "getApk",




  // Earning Router
  packageList: "package-list",
  subscribedPackageList: "subscribed-package-list",
  earningPortfolio: "earning-portfolio",
  subscribeEarningPackage: "subscribe-earning-package",


  // Arbitrage Router
  getPackageList: "bot-package-listing",
  buyArbitrageBot: "buy-arbitrage-bot",
  addFunds: "add-funds",
  getActivePackage: "get-active-package",
  getInvestment: "get-investment",


  // Futures Router

  order: "order",
  cancel: "cancel",
  closePosition: "close-position",

  // annoucemnt Router

  getAnnouncementCategoryList: "announcement-category-list",
  getAnnouncementList: "announcement-listing",
  announcementView: "announcement-view",


  // Launchpad Router

  getUserlpList: "user-launchpad-listing",
  getUpcominglpList: "upcoming-launchpad-listing",
  getCancellpList: "cancelled-launchpad-listing",
  getLiveListing: "live-launchpad-listing",
  getEndedListing: "ended-launchpad-listing",
  getUserPurchingList: "user-purchaseing-listing",
  tokenPurches: "purchase-token",
  userlpDetails: "user-launchpad-details",
  subscriptionHistory: "user-token-subscription-history",
  launchpadTransHistory: "user-token-transaction-history",

  // P2P Routes
  getCurrency: "getCurrency",
  getFiatCurrency: "getFiatCurrency",
  getAllPaymentMethods: "getAllPaymentMethods",
  p2pSellOrderForBuyer: "p2pSellOrderForBuyer",
  p2pBuyOrderForSeller: "p2pBuyOrderForSellers",
  getPaymentMethodFields: "getPaymentMethodFields",
  addUserPaymentMethod: "addUserPaymentMethod",
  getUserPaymentMethods: "getUserPaymentMethods",
  deleteUserPaymentMethod: "deletePaymentMethod",
  createAd: "createAd",
  buyFromAd: "buyFromAd",
  sellFromAd: "sellFromAd",
  getP2pOrderDetails: "getOrderDetails",
  getP2pOrders: "orders",
  getPairPrice: "getPairPrice",

  // P2P Order Actions
  markPaymentCompleted: "markPaymentCompleted",
  releaseCrypto: "releaseCrypto",
  cancelP2pOrder: "cancelOrder",
  buyerDispute: "buyerDispute",
  sellerDispute: "sellerDispute",

  // P2P Chat endpoints
  sendChatMessage: "chat/send",
  uploadChatImage: "chat/upload",
  getChatHistory: "chat",
  markChatRead: "chat/read",
  getChatUnreadCount: "chat/unread/count",
  deleteChatMessage: "chat/delete",
  getUserAds: "getUserAds",
  closeAd: "closeAd",
  updateAdStatus: "updateAdStatus",
  getP2pProfile: "profile",

  // Copy Trading (user website)
  copyTradingMasters: "copy-trading/masters",
  copyTradingMaster: "copy-trading/master/",
  copyTradingFollow: "copy-trading/follow",
  copyTradingUnfollow: "copy-trading/unfollow",
  copyTradingMyFollowing: "copy-trading/my-following",
  copyTradingHistory: "copy-trading/history",
  copyTradingPnl: "copy-trading/pnl",


  // ============URLs================

  baseUrl: `${appUrl}/`,
  baseImage: `${appUrl2}/`,
  baseAuth: `${appUrl}/v1/user/`,
  baseUserBot: `${appUrl}/v1/bot/`,
  baseEarning: `${appUrl}/v1/earning/`,
  basePartner: `${appUrl}/v1/partnerShip/`,
  baseTrans: `${appUrl}/v1/transaction/`,
  baseExchange: `${appUrl}/v1/exchange/`,
  baseAdmin: `${appUrl}/v1/admin/`,
  baseWallet: `${appUrl}/v1/wallet/`,
  baseCoin: `${appUrl}/v1/coin/`,
  baseP2p: `${appUrl}/v1/p2p/`,
  baseSupport: `${appUrl}/v1/support/`,
  baseNotification: `${appUrl}/v1/notifications/`,
  baseSwap: `${appUrl}/v1/qbs/`,
  baseCvbot: `${appUrl}/v1/cvbot/`,
  baseCoinList: `${appUrl}/v1/coin-listing/`,
  baseFutures: `${appUrl}/v1/futures/`,
  baseOptions: `${appUrl}/v1/options/`,
  // ============webSocketUrl================

  webSocketUrl: appUrl,
};
